export const usePrepareDate = () => {
  /**
   * @param date Date|undefined
   * */
  function setOffset (date) {
    if (!date) return date

    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
  }
  /**
   * @param date Date|undefined
   * */
  function formatDate (date) {
    if (!date) return date

    return date.toISOString().split('T')[0]
  }
  /**
   * @param date string|undefined
   * */
  function formattedToLocal (date) {
    if (!date) return date

    return date.split('-').reverse().join('.')
  }
  /**
   * @param date string|undefined
   * */
  function localToFormatted (date) {
    if (!date) return date

    return date.split('.').reverse().join('-')
  }

  return { setOffset, formatDate, formattedToLocal, localToFormatted }
}
